import $api from "../../axios"
import { changeCampaignStatusBody } from "../../types/customers"

const api = "/sp/campaignsSkc/"

export const changeCampaignStatus = async (data: changeCampaignStatusBody) => {
  await $api.put(`${api}updateCampaignsState`, data)
}
